import {JWT} from '../../models/Ilogin';
import {Dispatch} from 'redux';

export const SET_JWT = 'SET_JWT';
export const CLEAR_JWT = 'CLEAR_JWT';

export interface SetJWT {
  type: 'SET_JWT';
  JWT: JWT;
}
export interface ClearJWT {
  type: 'CLEAR_JWT';
}

export type KnownAction = SetJWT | ClearJWT;

export const actionCreators = {
  SetJWT: (JWT: JWT) => {
    return (dispatch: Dispatch<KnownAction>) => {
      dispatch({
        type: SET_JWT,
        JWT: JWT,
      });
    };
  },
  ClearJWTInfo: () => {
    return (dispatch: Dispatch<KnownAction>) => {
      dispatch({
        type: CLEAR_JWT,
      });
    };
  },
};
